import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { MouseEventHandler, useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import ClubSelector from "@main/clubs/components/ClubSelector";
import CategorySelector from "@main/categories/components/CategorySelector";
import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
    className?: string;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => MouseEventHandler;
  backendFormErrors: any;
}

function PlayerForm(props: Prop) {
  const { formRef, onSubmit, context, className } = props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});

  const translations = {
    img: t("img"),
    alias: t("alias"),
    name: t("name"),
    lastname: t("lastname"),
    second_lastname: t("second_lastname"),
    nif: t("nif"),
    birthdate: t("birthdate"),
    email: t("email"),
    phone: t("phone"),
    nationality: t("nationality"),
    paid: t("paid"),
    data_protection: t("data_protection"),
    club_id: t("club_id"),
    category_id: t("category_id"),
  };

  let schema: RJSFSchema = {
    type: "object",
    // required: ['minutes', 'customer_id', 'task', 'date', 'report_id'],
    properties: {
      alias: {
        type: "string",
        title: translations.alias,
      },
      name: {
        type: "string",
        title: translations.name,
      },
      lastname: {
        type: "string",
        title: translations.lastname,
      },
      second_lastname: {
        type: "string",
        title: translations.second_lastname,
      },
      nif: {
        type: "string",
        title: translations.nif,
      },
      birthdate: {
        type: "string",
        title: translations.birthdate,
        format: "date",
      },
      email: {
        type: "string",
        title: translations.email,
      },
      phone: {
        type: "string",
        title: translations.phone,
      },
      nationality: {
        type: "string",
        title: translations.nationality
      },
      data_protection: {
        type: "boolean",
        title: translations.data_protection,
      },
      club_id: {
        type: "number",
        title: translations.club_id,
      },
      img: {
        type: "array",
        title: translations.img,
        items: {
          type: "object",
          properties: {
            filename: { type: "string", title: "filename" },
            url: { type: "string", title: "url" },
          },
        }
      },
    },
  };
  const uiSchema: UiSchema = {
    "ui:classNames": className,
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    img: {
      "ui:widget": "file-input",
    },
    paid: {
      "ui:widget": "switch",
    },
    data_protection: {
      "ui:widget": "switch",
    },
    club_id: {
      "ui:widget": "club-selector",      
    },
    category_id: {
      "ui:widget": "category-selector",
    },
  };
  const customWidgets = {
    ...widgets,
    ...{
      "switch": BeelditSwitchInput,
      "category-selector": CategorySelector,
      "club-selector": ClubSelector,
    },
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  return (
    <JSONSchemaForm
      noHtml5Validate
      showErrorList={false}
      ref={formRef}
      schema={schema}
      uiSchema={uiSchema}
      widgets={customWidgets}
      formData={element}
      validator={validator}
      onChange={handleChange}
      onSubmit={onSubmit}
      onError={log("errors")}
      extraErrors={backendFormErrors}
    />
  );
}

export default PlayerForm;
